import { render } from "./AppRenameFile.vue?vue&type=template&id=0d3c00d2&scoped=true&ts=true"
import script from "./AppRenameFile.vue?vue&type=script&lang=ts"
export * from "./AppRenameFile.vue?vue&type=script&lang=ts"

import "./AppRenameFile.vue?vue&type=style&index=0&id=0d3c00d2&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d3c00d2"]])

export default __exports__